import * as d3 from 'd3'
import Chart from '../../ultils/Chart'
import emptyThumb from '../../assets/images/emptydata.svg'
import './styles.css'
import d3tip from '../../ultils/d3-tip'

class ProjectionChart extends Chart {
  init({ data, inModal, estimateChartFrequency }) {
    let vis = this
    vis.data = data
    vis.inModal = inModal
    vis.estimateChartFrequency = estimateChartFrequency

    vis.parseTime = d3.timeParse('%d/%m/%Y')
    vis.formatTime = d3.timeFormat('%d/%m/%Y')
    vis.bisectDate = d3.bisector(d => d.date).left

    vis.areaPath = vis.g
      .append('path')
      .attr('class', 'area')
      .attr('fill', '#EAF0F6')

    vis.linePath = vis.g
      .append('path')
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', '#3ABFC7')
      .attr('stroke-width', '2px')

    vis.consensusLinePath = vis.g
      .append('path')
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', '#3073C3')
      .attr('stroke-width', '2px')

    vis.focus = vis.g
      .append('g')
      .attr('class', 'focus')
      .style('display', 'none')

    vis.focus
      .append('line')
      .attr('class', 'x-hover-line hover-line')
      .attr('y1', 0)
      .attr('y2', vis.HEIGHT)

    vis.focus
      .append('circle')
      .attr('class', 'concensusCircle')
      .attr('r', 4)
      .attr('fill', '#3ABFC7')

    vis.focus
      .append('circle')
      .attr('class', 'smartConcensusCircle')
      .attr('r', 4)
      .attr('fill', '#3073C3')

    vis.x = d3.scaleTime()
    vis.y = d3.scaleLinear()

    vis.xAxisCall = d3
      .axisBottom()
      .ticks(inModal ? 8 : 2)
      .tickSizeOuter(0)
      .tickFormat(d3.timeFormat('%b %Y'))
    vis.yAxisCall = d3
      .axisLeft()
      .ticks(inModal ? 6 : 4)
      .tickSizeOuter(0)

    vis.xAxis = vis.g
      .append('g')
      .attr('class', 'x axisProjectionChart')
      .attr('transform', `translate(0, ${vis.HEIGHT})`)
    vis.yAxis = vis.g.append('g').attr('class', 'y axisProjectionChart')

    vis.yLegend = vis.svg
      .append('text')
      .attr('class', inModal ? 'axis-label label-in-modal' : 'axis-label')
      .attr('text-anchor', 'middle')
      .attr('x', 50)
      .attr('y', 10)
    vis.update({ data })
    vis.createTooltip()
  }

  formatNumber(number) {
    return !isNaN(number) ? Number(number).toFixed(2) : number
  }

  showSpread(dspread, daccuracy) {
    if (!daccuracy) {
      return 'N/A'
    }
    const percentage =
      !isNaN(dspread) && dspread !== null
        ? `${(Number(dspread) * 100).toFixed(2)} %`
        : 'N/A'
    return percentage
  }

  showAccuracy(dspread, daccuracy) {
    if (!daccuracy) {
      return 'N/A'
    }
    const percentage =
      !isNaN(daccuracy) && daccuracy !== null
        ? `${Number(daccuracy).toFixed(2) * 100} %`
        : 'N/A'
    return percentage
  }

  mousemove(e) {
    let vis = this
    if (vis.data.length > 0) {
      const x0 = vis.x.invert(d3.pointer(e)[0] - vis.MARGIN.LEFT)
      const i = vis.bisectDate(vis.data, x0, 1, vis.data.length - 1)
      const d0 = vis.data[i - 1]
      const d1 = vis.data[i]
      const d = x0 - d0.date > d1.date - x0 ? d1 : d0

      vis.focus
        .select('.x-hover-line')
        .attr('x1', vis.x(d.date))
        .attr('x2', vis.x(d.date))

      vis.focus
        .select('.concensusCircle')
        .attr('cx', vis.x(d.date))
        .attr('cy', vis.y(d['street_average']))

      vis.focus
        .select('.smartConcensusCircle')
        .attr('cx', vis.x(d.date))
        .attr('cy', vis.y(d['90daverage']))

      vis.tip.show(e, d, 10, -d3.pointer(e)[1] + 8)
    }
  }

  createTooltip() {
    const vis = this
    const inModal = vis.inModal ? '-inModal' : '-notInModal'
    d3.selectAll(`.projectionChart${inModal}`).remove()
    vis.tip = d3tip()
      .attr('class', `d3-tip-estimate-chart projectionChart${inModal}`)
      .html((e, d) => vis.generateTooltipHtml(d))
    vis.g.call(vis.tip)
  }

  generateTooltipHtml(d) {
    const vis = this
    return `
          <div class="tip-content">
            <div class="tip-header">
              <div class="estimate-chart-tip-title">
                  ${d3.timeFormat('%d %B %Y')(new Date(d.date))}
              </div>
              <div class="tip-content">
                <div class="row">
                  <div class="estimate-chart-row-title">
                    <span class="dot" style="background-color: #34D8E2;"></span> Consensus: 
                  </div>
                  <div class="estimate-chart-row-content">${vis.formatNumber(
                    d['street_average'],
                  )}</div>
                </div>
                <div class="row">
                  <div class="estimate-chart-row-title">
                    <span class="dot" style="background-color: #1D82F9;"></span> Smart Consensus: 
                  </div>
                  <div class="estimate-chart-row-content">${vis.formatNumber(
                    d['90daverage'],
                  )}</div>
                </div>
                <div class="row">
                  <div class="estimate-chart-row-title">Spread: </div>
                  <div class="estimate-chart-row-content">${vis.showSpread(
                    d['90dspread'],
                    d['90daccuracy'],
                  )}</div>
                </div>
                <div class="row">
                  <div class="estimate-chart-row-title">Historic Accuracy: </div>
                  <div class="estimate-chart-row-content">${vis.showAccuracy(
                    d['90dspread'],
                    d['90daccuracy'],
                  )}</div>
                </div>
              </div>
            </div>
          </div>
        `
  }

  update({ data, estimateChartFrequency }) {
    let vis = this
    vis.data = data || vis.data
    vis.estimateChartFrequency =
      estimateChartFrequency || vis.estimateChartFrequency
    vis.svg.selectAll('image').remove()

    if (vis.data.length <= 1) {
      vis.data = []
      vis.svg
        .append('svg:image')
        .attr('xlink:href', emptyThumb)
        .attr('x', vis.WIDTH / 2 - 77 + vis.MARGIN.LEFT)
        .attr('y', vis.HEIGHT / 2 - 37 + vis.MARGIN.TOP)
        .attr('width', '155')
        .attr('height', '73')
      if (vis.yLegend) {
        vis.yLegend.text('')
      }
    } else {
      vis.data = vis.data.filter(
        d => d.frequency === vis.estimateChartFrequency,
      )
      if (vis.yLegend) {
        vis.yLegend.text('EPS')
      }
    }

    vis.data = vis.data.sort((a, b) => a.date - b.date)

    vis.t = d3.transition().duration(1000)

    vis.x.range([0, vis.WIDTH]).domain(d3.extent(vis.data, d => d.date))
    vis.y.range([vis.HEIGHT, 0]).domain([
      d3.min(vis.data, d => {
        const min = d3.min([
          Number(d['fe_low']),
          Number(d['street_average']),
          Number(d['90daverage']),
        ])
        return min > 0 ? 0.98 * min : 1.02 * min
      }),
      d3.max(vis.data, d => {
        const max = d3.max([
          Number(d['fe_high']),
          Number(d['street_average']),
          Number(d['90daverage']),
        ])
        return max > 0 ? 1.02 * max : 0.98 * max
      }),
    ])

    vis.xAxisCall.scale(vis.x)
    vis.xAxis.transition(vis.t).call(vis.xAxisCall)
    vis.yAxisCall.scale(vis.y)
    vis.yAxis.transition(vis.t).call(vis.yAxisCall)

    vis.line = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d['street_average']))
      .x(d => vis.x(d.date))
      .y(d => vis.y(d['street_average']))

    vis.consensusLine = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d['90daverage']))
      .x(d => vis.x(d.date))
      .y(d => vis.y(d['90daverage']))

    vis.area = d3
      .area()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d['fe_low']) && !isNaN(d['fe_high']))
      .x(d => vis.x(d.date))
      .y0(d => vis.y(d['fe_low']))
      .y1(d => vis.y(d['fe_high']))

    vis.linePath.attr('d', vis.line(vis.data))
    vis.consensusLinePath.attr('d', vis.consensusLine(vis.data))
    vis.areaPath.attr('d', vis.area(vis.data))

    vis.svg
      .on('mousemove', e => vis.mousemove(e))
      .on('mouseover', () => {
        vis.focus.style('display', null)
        vis.tip.hide()
      })
      .on('mouseout', () => {
        vis.tip.hide()
        vis.focus.style('display', 'none')
      })
  }
}

export default ProjectionChart
